import { render, staticRenderFns } from "./MailingBossForm.vue?vue&type=template&id=6b4c8fde&scoped=true&"
import script from "./MailingBossForm.vue?vue&type=script&lang=js&"
export * from "./MailingBossForm.vue?vue&type=script&lang=js&"
import style0 from "./MailingBossForm.vue?vue&type=style&index=0&id=6b4c8fde&scoped=true&lang=scss&"
import style1 from "./MailingBossForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4c8fde",
  null
  
)

export default component.exports